/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetCustomerCartOverviewQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']['input'];
  platform: Types.Platform;
  market: Types.Market;
  request: Types.ComputeCartTotalInput;
}>;

export type GetCustomerCartOverviewQuery = { __typename?: 'Query' } & {
  findCustomerCart: Types.Maybe<
    { __typename?: 'CustomerCart' } & Pick<Types.CustomerCart, 'platform'> & {
        items: Array<
          { __typename?: 'CartItem' } & Pick<Types.CartItem, 'quantity'> & {
              product: { __typename?: 'ChannelOffer' } & Pick<
                Types.ChannelOffer,
                'productId'
              >;
            }
        >;
      }
  >;
  computeTotalForCart: { __typename?: 'CartComputation' } & {
    totalCartPriceToBePaidByTheCustomerVatIncl: {
      __typename?: 'ComputationPrice';
    } & Pick<Types.ComputationPrice, 'amount'>;
  };
};

export const GetCustomerCartOverviewDocument = /*#__PURE__*/ `
    query getCustomerCartOverview($customerId: Int!, $platform: Platform!, $market: Market!, $request: ComputeCartTotalInput!) {
  findCustomerCart(customerId: $customerId, platform: $platform, market: $market) {
    platform
    items {
      quantity
      product {
        productId
      }
    }
  }
  computeTotalForCart(request: $request) {
    totalCartPriceToBePaidByTheCustomerVatIncl {
      amount
    }
  }
}
    `;

export function useGetCustomerCartOverviewQuery(
  options: Omit<
    Urql.UseQueryArgs<GetCustomerCartOverviewQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetCustomerCartOverviewQuery,
    GetCustomerCartOverviewQueryVariables
  >({ query: GetCustomerCartOverviewDocument, ...options });
}
